export default __webpack_public_path__ + "assets/img/Submit_Sucs.c869d3fb.svg";